import axios from 'axios';
import '../App.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import ChartAdsCount from '../ChartAdsCount';
import ChartAdsTime from '../ChartAdsTime';
import DeviceStatsTopCampaigns from './DeviceStatsTopCampaigns';
import ChartDeviceRevenue from '../ChartDeviceRevenue';
import Header from '../Header';
import DeviceHeader from './DeviceHeader';
import V2Card from '../V2Card';

function DeviceStats({ menu }) {
    const e6 = 100000;
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const [adsCount, setAdsCount] = useState(0);
    const [adsTime, setAdsTime] = useState(0);
    const [deviceBalanceE6, setDeviceBalanceE6] = useState(0);

    function getAdsCount() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/device/stats/ads/count/?device_id=${searchParams.get('device_id')}`
        ).then(
            (response) => {
                setAdsCount(response.data.count);
            }
        )
    }

    function getAdsTime() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/device/stats/ads/time/?device_id=${searchParams.get('device_id')}`
        ).then(
            (response) => {
                setAdsTime(response.data.sum);
            }
        )
    }

    function prettyTime(t) {
        if (!t) {
            return 0;
        }

        if (t < 60) {
            return `${t.toFixed(1)} seconds`;
        }
        if (t < 60 * 60) {
            return `${(t / 60).toFixed(1)} minutes`;
        }
        return `${(t / (60 * 60)).toFixed(1)} hours`;
    }

    // TODO: remove dup.
    function getDeviceBalanceE6(device_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/device/balance/?device_id=${device_id}`,
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                setDeviceBalanceE6(response.data.balance);
            }
        ).catch(
            (error) => {

            }
        )
    }

    useEffect(
        () => {
            getAdsCount();
            getAdsTime();
            getDeviceBalanceE6(searchParams.get('device_id'));
        },
        [],
    )

    return (
        <div align='center'>
            {menu}
            <DeviceHeader title='Device Statistics' />
            <V2Card>
                <V2Card>
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{ marginRight: '4em' }}>
                            <h3>
                                Ads
                            </h3>
                            <h1>
                                {adsCount}
                            </h1>
                        </div>
                        <div style={{ marginRight: '4em' }}>
                            <h3>
                                Screen Time
                            </h3>
                            <h1>
                                {prettyTime(adsTime)}
                            </h1>
                        </div>
                        <div>
                            <h3>
                                Eligible Revenue
                            </h3>
                            <h1>
                                {deviceBalanceE6 / e6} EUR
                            </h1>
                        </div>
                    </div>
                </V2Card>
                <V2Card>
                    <ChartAdsCount
                        device_id={searchParams.get('device_id')}
                    />
                </V2Card>
                <V2Card>
                    <ChartAdsTime
                        device_id={searchParams.get('device_id')}
                    />
                </V2Card>
                <V2Card>
                    <ChartDeviceRevenue
                        device_id={searchParams.get('device_id')}
                    />
                </V2Card>
                <V2Card>
                    <DeviceStatsTopCampaigns
                        device_id={searchParams.get('device_id')}
                    />
                </V2Card>
            </V2Card>
        </div>
    );
}

export default DeviceStats;